import React from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
import { ConfiguredReport } from 'components/reporting/sidebar/ConfiguredReport';
import Chart from './charts/Chart';
import ChartDimensions from './ChartDimensions';
import defaultChartConfiguration from './defaultChartConfiguration';

function PublishedChart({ data, configuration, meta, chartType }) {
  return (
    <ErrorBoundary>
      <ConfiguredReport
        meta={meta}
        configuration={configuration}
        defaultConfiguration={defaultChartConfiguration(chartType)}
      >
        <ChartDimensions meta={meta}>
          {({ measureRef, width, height }) => (
            <div
              ref={measureRef}
              style={{
                overflow: 'hidden',
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
              }}
            >
              <div
                className='custom-chart-wrapper'
                style={{ width: width, height: height, overflow: 'hidden' }}
              >
                <Chart
                  data={data}
                  meta={meta}
                  chartType={chartType}
                  width={width}
                  height={height}
                  publishing
                />
              </div>
            </div>
          )}
        </ChartDimensions>
      </ConfiguredReport>
    </ErrorBoundary>
  );
}
export default PublishedChart;
